import { useEffect, useState } from 'react';

export function AvailabilityWindowsEditor({ member, roster, compact = false }) {
  const original = member?.availabilityWindows || [];
  const [draft, setDraft] = useState(original);
  useEffect(() => setDraft(original), [member?.availabilityWindows]);

  const saving = roster.workingOpenid === member.memberOpenid;
  const changed = JSON.stringify(draft) !== JSON.stringify(original);
  const updateWindow = (index, key, value) => setDraft((current) => current.map((item, cursor) => cursor === index ? { ...item, [key]: value } : item));
  const addWindow = () => setDraft((current) => current.length >= 8 ? current : [...current, { start: '19:00', end: '20:00' }]);
  const removeWindow = (index) => setDraft((current) => current.filter((_, cursor) => cursor !== index));

  return (
    <div className={`availability-windows-editor ${compact ? 'compact' : ''}`}>
      <div className="availability-windows-list">
        {draft.length ? draft.map((item, index) => (
          <div className="availability-window-row" key={`${index}-${item.start}-${item.end}`}>
            <input type="time" value={item.start} disabled={saving} onChange={(event) => updateWindow(index, 'start', event.target.value)} aria-label={`${member.nickname} 접속 시작 ${index + 1}`} />
            <span>~</span>
            <input type="time" value={item.end} disabled={saving} onChange={(event) => updateWindow(index, 'end', event.target.value)} aria-label={`${member.nickname} 접속 종료 ${index + 1}`} />
            <button className="danger" type="button" disabled={saving} onClick={() => removeWindow(index)}>삭제</button>
          </div>
        )) : <p className="availability-windows-empty">설정된 접속시간 없음</p>}
      </div>
      <div className="availability-windows-actions">
        <button type="button" className="secondary" disabled={saving || draft.length >= 8} onClick={addWindow}>+ 시간 추가</button>
        <button type="button" className="primary" disabled={saving || !changed} onClick={() => roster.saveAvailability(member.memberOpenid, draft)}>{saving ? '저장 중…' : '저장'}</button>
      </div>
      <small>최대 8개 · 자정을 넘는 시간 설정 가능</small>
    </div>
  );
}
